import Swiper from "swiper";
import { Navigation } from "swiper/modules";

jQuery(($) => {
	// get classes
	const classes = $(".two-columns-cpt-slider").attr("class");
	let loopy = classes && classes.includes("no-loop") ? false : true;

	const swiperCPTSlider = new Swiper(".swiper-cpt-slider", {
		loop: loopy,
		slidesPerView: "auto",
		spaceBetween: 30,
		centeredSlides: false,
		navigation: {
			nextEl: ".swiper-button-next-cpt-slider",
			prevEl: ".swiper-button-prev-cpt-slider",
		},
		modules: [Navigation],
		breakpoints: {
			1024: { spaceBetween: 30 },
			0: {
				spaceBetween: 0,
			},
		},
	});
});
